import React, { FC, ReactNode } from "react";
import { makeStyles, IconButton, Box } from "@material-ui/core";
import { color, px } from "Configs/theme";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

interface Props {
	title: string;
	customTitle?: ReactNode;
	isOpen: boolean;
	setIsOpen: (isOpen: boolean) => void;
}

const CalendarSubHeadRow: FC<Props> = (props) => {
	const classes = useStyles();

	return (
		<Box className={classes.root}>
			<IconButton size="small" onClick={() => props.setIsOpen(!props.isOpen)}>
				<ChevronRightIcon
					className={classes.icon}
					fontSize="inherit"
					style={{
						transform: props.isOpen ? "rotate(90deg)" : "rotate(0deg)",
					}}
					htmlColor={color.text}
				/>
			</IconButton>
			<Box display="flex" flex={1} ml={px.s}>
				{props.customTitle || props.title}
			</Box>
			{props.children}
		</Box>
	);
};

export default CalendarSubHeadRow;

const useStyles = makeStyles({
	root: {
		display: "flex",
		alignItems: "center",
		backgroundColor: color.tableHeadBackground,
		borderBottom: `1px solid ${color.tableCellBorder}`,
		fontWeight: "bold",
		height: px.xxl,
		padding: px.none,
		paddingLeft: px.xl,
		fontSize: "12px",
		textTransform: "uppercase",
	},
	icon: {
		transition: ".3s all",
	},
});
